export default function injectDates(feature, dateKeys) {
  const featureIsoDatesObj = {};
  dateKeys.forEach((item) => {
    if (!feature.attributes[item]) return null;
    const isoDate = new Date(feature.attributes[item]).toLocaleString("en-GB", {
      month: "numeric",
      day: "numeric",
      year: "numeric",
      hour: "numeric",
      minute: "numeric",
      hour12: true,
    });
    featureIsoDatesObj[`${item}_ISO`] = isoDate;
    // to shut up esling this is dull line !
    return null;
  });
  return featureIsoDatesObj;
}
